/* eslint-disable prefer-template */

import loadable from '@loadable/component';

export default loadable((props) => import('../pages/' + props.page));
